module.exports = "/_next/static/images/LeveragePreBuiltCloudSources@2x-7d99614e52c981ed1f05a70619b891cf.png";